import React, { useEffect, useState } from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { checkDocsSettings } from "../../../Tools/Tools";

export const defaultDocsSettings = {
  save: {
    label: "Предупреждать о несохраненных изменениях при переходе на другую секцию",
    disabled: false,
    checked: true,
  },
  dbclick: { label: "Открывать  карточку документа по двойному щелчку мыши", disabled: true, checked: false },
  border: { label: "Выделять текущую запись запись таблицы детализации рамкой", disabled: true, checked: false },
  activeRecord: { label: "Восстанавливать активный документ при следующем входе", disabled: false, checked: true },
};

export default function CheckBoxedForDocandSettings(props) {
  const [checkBoxes, setCheckBoxes] = useState(defaultDocsSettings);

  useEffect(() => {
    const docState = checkDocsSettings();
    if (docState === null || docState === "") return;
    setCheckBoxes(docState);
  }, []);

  const onCheckChange = (key) => {
    if (key) {
      const checkState = {
        ...checkBoxes,
        [key]: { ...checkBoxes[key], checked: !checkBoxes[key].checked },
      };
      localStorage.setItem("docState", JSON.stringify(checkState));
      setCheckBoxes(checkState);
    }
  };

  return (
    <FormGroup>
      {Object.entries(checkBoxes).map(([key, value]) => {
        return (
          <FormControlLabel
            disabled={value.disabled}
            id={key}
            key={key}
            onChange={() => {
              onCheckChange(key);
            }}
            control={<Checkbox id={key} checked={value.checked} />}
            label={value.label}
          />
        );
      })}
    </FormGroup>
  );
}
